module.exports = __webpack_public_path__ + "img/gromophon.4e8a1b5b.svg";